import { useSelector } from 'react-redux'
import './styles/index.scss'

/**
 * Loader V1 - existing image based loader
 * Now supports usage at page, section, and component levels via props
 *
 * @param {Object} props
 * @param {string|number} [props.top]
 * @param {string} [props.position='relative']
 * @param {number|string} [props.zIndex]
 * @param {string|number} [props.bottom]
 * @param {('page'|'section'|'component')} [props.mode]
 * @param {boolean} [props.fullscreen]
 * @param {boolean} [props.overlay]
 * @param {boolean} [props.compact]
 * @param {string|number} [props.height]
 * @param {string} [props.className]
 * @param {Object} [props.style]
 */
const LoaderV1 = ({
  top,
  position = 'relative',
  zIndex,
  bottom,
  mode,
  fullscreen,
  overlay,
  compact,
  height,
  className,
  style
}) => {
  const { languageData: { loaderLogo } = {} } = useSelector(state => state.language)

  const isFullscreen = Boolean(fullscreen || mode === 'page')
  const isCompact = Boolean(compact || mode === 'component')
  const isOverlay = Boolean(overlay)

  const classes = [
    'parent', // legacy class for existing styles
    'loader',
    isFullscreen && 'loader--fullscreen',
    isOverlay && 'loader--overlay',
    isCompact && 'loader--compact',
    className
  ].filter(Boolean).join(' ')

  const computedStyle = {
    ...(style || {}),
    marginTop: top || '',
    marginBottom: bottom || '',
    position,
    zIndex,
    minHeight: height || undefined
  }

  return (
    <div className={classes} style={computedStyle}>
      <div className='loader__content'>
        <img
          className='image1'
          src={loaderLogo || `${process.env.REACT_APP_STATIC_IMAGE}/loader-logo.svg`} alt='logo'
        />
        <div className='loader__progress' role='progressbar' aria-valuemin='0' aria-valuemax='100' aria-label='Loading'>
          <div className='loader__track'>
            <div className='loader__fill' />
          </div>
        </div>
      </div>
      <img
        className='image2'
        src={`${process.env.REACT_APP_STATIC_IMAGE}/roundloader.png` || '/images/roundloader.png'} alt='bg-loader'
      />
    </div>
  )
}

export default LoaderV1
